import {
  BodyText,
  Button,
  ButtonGroup,
  Divider,
  Stack,
  Tag,
  Toast,
} from '@servicetitan/design-system';
import styles from './IncomingCallToast.module.css';
import maskPhoneNumber from '@lib/utils/maskPhoneNumber';
import TenantName from '@components/TenantName/TenantName';
import classNames from 'classnames';
import { IncomingCallToastType } from '@modules/ToastModule/types';
import TasksModule from '@modules/TasksModule';

const TOAST_DURATION = 60_000 * 60; // 1 hour
export interface IncomingCallToastProps extends IncomingCallToastType {}

const IncomingCallToast = ({
  id,
  displayName,
  from,
  tenantId,
  isInternal,
}: IncomingCallToastProps) => {
  const callFrom = displayName ?? maskPhoneNumber(from);

  const handleAcceptCall = () => {
    TasksModule.actionTask(id, 'accept');
  };

  const handleRejectCall = () => {
    TasksModule.actionTask(id, 'reject');
  };

  return (
    <Toast
      className={classNames(styles.incomingCallToast, 'p-2')}
      title='Incoming Call'
      duration={TOAST_DURATION}
    >
      <div>
        <Stack direction='column' spacing={1}>
          <Stack spacing={1} alignItems='center'>
            <Stack.Item>
              <BodyText size='small'>{callFrom}</BodyText>
            </Stack.Item>
            <Stack.Item>
              <Divider className='c-neutral-80' vertical />
            </Stack.Item>
            <Stack.Item>
              {!isInternal && tenantId ? (
                <TenantName tenantNameOrId={tenantId} />
              ) : (
                <Tag color='inactive' subtle compact>
                  Internal
                </Tag>
              )}
            </Stack.Item>
          </Stack>
          <ButtonGroup>
            <Button color='negative' onClick={handleRejectCall}>
              Reject
            </Button>
            <Button color='primary' onClick={handleAcceptCall}>
              Accept Call
            </Button>
          </ButtonGroup>
        </Stack>
      </div>
    </Toast>
  );
};

export default IncomingCallToast;
